import { useEffect, useState } from "react";
import { fdeProjectPath, fdeRoutes } from "@/frontend/features/Fde/routes";
import type { DataPreviewResult, ForgeQueryFilter } from "@/frontend/features/Fde/data/types";

export default function useDataPreview(projectId: string | null | undefined, model: string | undefined, fields: string[], filters: ForgeQueryFilter[], errorLabel: string) {
  const [result, setResult] = useState<DataPreviewResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fieldKey = fields.join("\u0000");
  const filterKey = JSON.stringify(filters);

  useEffect(() => {
    if (!projectId || !model || fields.length === 0) return;
    const controller = new AbortController();
    setResult(null);
    setError(null);
    fetch(fdeProjectPath(`${fdeRoutes.data}/preview`, projectId), {
      method: "POST",
      credentials: "same-origin",
      signal: controller.signal,
      headers: { Accept: "application/json", "Content-Type": "application/json", "X-CSRF-Token": document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || "" },
      body: JSON.stringify({ model, fields, filters, limit: 1_000 }),
    })
      .then(async (response) => { const payload = await response.json(); if (!response.ok) throw new Error(payload.error || errorLabel); return payload as DataPreviewResult; })
      .then(setResult)
      .catch((requestError: Error) => { if (requestError.name !== "AbortError") setError(requestError.message); });
    return () => controller.abort();
  }, [errorLabel, fieldKey, filterKey, model, projectId]);

  return { result, error };
}
